module.exports = __webpack_public_path__ + "media/app/assets/races/vulpera_female-73f2f2e20511b261cbc67489452c8819.png";